export default __webpack_public_path__ + "static/media/COSM110.3e041b5a.PNG";